"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthRedirectEvent = void 0;
var AuthRedirectEvent;
(function (AuthRedirectEvent) {
    AuthRedirectEvent["Microsoft"] = "MicrosoftAuthRedirect";
    AuthRedirectEvent["Google"] = "GoogleAuthRedirect";
    AuthRedirectEvent["Salesforce"] = "SalesforceAuthRedirect";
})(AuthRedirectEvent = exports.AuthRedirectEvent || (exports.AuthRedirectEvent = {}));
